/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";

// Timeline context
import { TimelineProvider } from "modules/inspections/components/InspectionTimeline/context";
import { Box } from "@mui/material";

function InspectionTimelineList({ title, dark = false, children }) {
  return (
    <TimelineProvider value={dark}>
      <SoftBox>
        <Box p={1}>
          {/* <SoftBox bgColor={dark ? "dark" : "white"} variant="gradient"> */}
          <SoftBox px={3}>
            <SoftTypography variant="h6" fontWeight="medium" color={dark ? "white" : "dark"}>
              {title}
            </SoftTypography>
          </SoftBox>
          <SoftBox p={1}>{children}</SoftBox>
          {/* </SoftBox> */}
        </Box>
      </SoftBox>
    </TimelineProvider>
  );
}


// Typechecking props for the InspectionTimelineList
InspectionTimelineList.propTypes = {
  title: PropTypes.string.isRequired,
  dark: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default InspectionTimelineList;
